import { useQuery } from 'react-query'
import { UseQueryResult } from 'react-query/types/react/types'
import { useFetchFromServer } from '../../api/fetchHook'
import { serverRoutes } from '../../layout/serverRoutes'
import { Check } from '../../../../shared/src/data/check'

export const useGetCheck = (): UseQueryResult<Check[]> => {
  const { fetchJsonFromServer } = useFetchFromServer()

  return useQuery('check', () =>
    fetchJsonFromServer<Check[]>(serverRoutes.api.check.route()),
  )
}
